import { Search, MessageSquare, Calendar, Rocket } from "lucide-react";

export function Process() {
    const steps = [
        { icon: Search, num: "01", title: "Diagnóstico", desc: "Analisamos sua clínica, mercado e concorrência para criar a melhor estratégia." },
        { icon: MessageSquare, num: "02", title: "Ativação da IA", desc: "Configuramos seu assistente virtual para atender e qualificar pacientes 24/7." },
        { icon: Calendar, num: "03", title: "Campanhas no Ar", desc: "Lançamos tráfego pago estratégico para atrair pacientes qualificados." },
        { icon: Rocket, num: "04", title: "Otimização Contínua", desc: "Monitoramos, ajustamos e escalamos seus resultados todos os dias." },
    ];

    return (
        <section className="py-20 bg-slate-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">Como funciona</h2>
                    <p className="text-slate-600 text-lg">4 passos simples para transformar sua clínica</p>
                </div>
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {steps.map((s, i) => (
                        <div key={i} className="bg-white rounded-2xl p-6 shadow-lg text-center relative">
                            <span className="absolute -top-3 -right-3 text-5xl font-bold text-brand-100">{s.num}</span>
                            <div className="w-14 h-14 bg-brand-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                                <s.icon className="w-7 h-7 text-white" />
                            </div>
                            <h3 className="text-lg font-bold text-slate-900 mb-2">{s.title}</h3>
                            <p className="text-slate-600 text-sm">{s.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
